<base-detail-page  [config]="baseDetailPageConfig" (onLoadedDetail)="onLoadedDetail($event)"></base-detail-page>